const udhrPreamble = `Considerant que el reconeixement de la dignitat inherent i dels drets iguals i inalienables de tots els membres de la família humana és el fonament de la llibertat, la justícia i la pau en el món,

Considerant que el desconeixement i el menyspreu dels drets humans han originat actes de barbàrie que han ultratjat la consciència de la humanitat; i que s'ha proclamat com l'aspiració més elevada de tothom l'adveniment d'un món on els éssers humans, deslliurats del temor i la misèria, puguin gaudir de llibertat d'expressió i de creença,

Considerant que és essencial que els drets humans siguin protegits per un règim de dret per tal que les persones no es vegin forçades, com a últim recurs, a la rebel_lió contra la tirania i l'opressió,

Considerant també que és essencial de promoure el desenvolupament de relacions amistoses entre les nacions,

Considerant que els pobles de les Nacions Unides han ratificat en la Carta llur fe en els drets humans fonamentals, en la dignitat i el valor de la persona humana i en la igualtat de dret d'homes i dones; i que han decidit de promoure el progrés social i millorar el nivell de vida dins d'una llibertat més àmplia,

Considerant que els Estats membres s'han compromès a assegurar, en cooperació amb l'Organització de les Nacions Unides, el respecte universal i efectiu dels drets humans i les llibertats fonamentals,

Considerant que una concepció comuna d'aquests drets i llibertats és de la més gran importància per al ple compliment d'aquest compromís,

L'Assemblea General

Proclama aquesta Declaració Universal de Drets Humans com l'ideal comú a assolir per a tots els pobles i nacions amb el fi que cada persona i cada institució, inspirant-se constantment en aquesta Declaració, promoguin, mitjançant I'ensenyament i l'educació, el respecte a aquests drets i llibertats i assegurin, amb mesures progressives nacionals i internacionals, el seu reconeixement i aplicació universals i efectius, tant entre els pobles dels Estats membres com entre els dels territoris sota llur jurisdicció. `;

const udhr1 = `
Tots els éssers humans neixen lliures i iguals en dignitat i en drets. Són dotats de raó i de consciència, i han de comportar-se fraternalment els uns amb els altres. 
`;

module.exports = {
  name: 'Catalan',
  udhrPreamble,
  udhr1,
  lang: 'ca'
};
